/* ADD Knowledge categories */
export const EDIT_CUSTOMER = "EDIT_CUSTOMER"
export const EDIT_CUSTOMER_SUCCESS = "EDIT_CUSTOMER_SUCCESS"
export const EDIT_CUSTOMER_CLEAN = "EDIT_CUSTOMER_CLEAN"
export const EDIT_CUSTOMER_ERROR = "EDIT_CUSTOMER_ERROR"
